// ---- autofocus software presets ----
// mode rel: outer point = k * min HFR; abs: outer HFR = targetHFR px; fine: fixed HFD-px/step rule
var SW=[
  {n:"NINA — hyperbolic (recommended)",mode:"rel",k:2.75,side:4,basis:"outer ~2.75× min HFR"},
  {n:"NINA — parabolic",mode:"rel",k:1.8,side:4,basis:"stay near CFZ"},
  {n:"Sequence Generator Pro (quadratic)",mode:"rel",k:2.0,side:4,basis:"9 data points, near CFZ"},
  {n:"ASIAIR",mode:"rel",k:2.5,side:5,basis:"5× out then verify"},
  {n:"Ekos / KStars — Linear 1-Pass",mode:"rel",k:2.5,side:5,basis:"quadratic fit"},
  {n:"FocusMax / Voyager RoboStar",mode:"abs",targetHFR:17.5,side:17,basis:"extremes ~35 HFD"},
  {n:"TheSkyX @Focus3 (self-characterizes)",mode:"fine",basis:"fine ~1.5 HFD/step"}
];

var $=function(id){return document.getElementById(id)};
var C206=206.265, DIFFK=251.64; // arcsec constants

function buildCameraSelect(){
  var s=$('cam'), groups={};
  CAMERAS.forEach(function(c,i){ (groups[c[0]]=groups[c[0]]||[]).push(i) });
  var html='<option value="">— manual entry —</option>';
  Object.keys(groups).sort(function(a,b){return a.toLowerCase().localeCompare(b.toLowerCase());}).forEach(function(b){
    html+='<optgroup label="'+b+'">';
    groups[b].forEach(function(i){var c=CAMERAS[i];
      html+='<option value="'+i+'">'+c[1]+' — '+c[2]+'µm '+c[3]+'</option>';});
    html+='</optgroup>';
  });
  s.innerHTML=html;
  s.onchange=function(){ if(s.value!==''){ $('px').value=CAMERAS[+s.value][2]; recompute(); } };
}
function buildSwSelect(){
  var s=$('sw');
  s.innerHTML=SW.map(function(w,i){return '<option value="'+i+'">'+w.n+'</option>'}).join('');
  s.value=0;
}

// Calibration: user measures travel with a dial indicator in mm (default) or decimal inches.
function applyCal(){
  var st=parseFloat($('calSteps').value), tr=parseFloat($('calTravel').value);
  var u=$('calUnit')?$('calUnit').value:'mm';
  if(!(st>0)||!(tr>0)){ alert('Enter both a step count and the measured travel.'); return; }
  var um=(u==='in')? tr*25400 : tr*1000;   // to microns
  var d=um/st;
  $('dstep').value=d.toPrecision(4);
  if($('calnote')){
    $('calnote').innerHTML='Measured '+tr+' '+(u==='in'?'in':'mm')+' over '+fmtInt(st)+' steps = <b>'+d.toPrecision(4)+' µm/step</b>.';
  }
  recompute();
}

function fmt(x,d){ if(!isFinite(x))return '—'; d=d==null?1:d;
  return x.toLocaleString(undefined,{minimumFractionDigits:d,maximumFractionDigits:d}); }
function fmtInt(x){ return isFinite(x)?Math.round(x).toLocaleString():'—'; }

var M={}; // shared model results for plot

function recompute(){
  var FL=parseFloat($('fl').value), N=parseFloat($('fr').value), red=parseFloat($('red').value)||1;
  var p=parseFloat($('px').value), see=parseFloat($('see').value), tol=parseFloat($('tol').value);
  var wl=parseFloat($('wl').value), d=parseFloat($('dstep').value);
  var apIn=parseFloat($('ap').value), kOv=parseFloat($('kfac').value), hfrIn=parseFloat($('hfrMeas').value);
  if(!(FL>0&&N>0&&p>0&&d>0)){ return; }
  var lam=wl/1000;                 // µm
  var Ne=N*red;                    // effective f-ratio
  var FLe=FL*red;                  // effective focal length
  var A=(apIn>0)?apIn:FL/N;        // aperture unchanged by reducer
  var scale=C206*p/FLe;            // arcsec/px
  var diff=DIFFK*lam/A;            // arcsec
  var seeT=0.2*diff+see;           // total seeing arcsec
  var CFZ=4.88*lam*Ne*Ne;          // µm
  var L10=0.30*CFZ;                // µm
  var NCFZ=0.00225*seeT*Math.sqrt(tol)*A*Ne*Ne; // µm
  // in-focus HFR: user-measured anchor if given, else seeing-limited, clamped to a detector-realistic minimum
  var floorHFR = (hfrIn>0) ? hfrIn : Math.max(0.5*seeT/scale, 1.2);
  var floorSrc = (hfrIn>0) ? 'measured' : (0.5*seeT/scale<1.2 ? 'floor 1.2px (undersampled)' : 'seeing-limited');
  var slopeStep=d/(2*Ne*p);        // HFR px per native step (wing)
  var stepsPerPx=1/slopeStep;      // native steps per 1 HFR px

  // eff line
  $('eff').innerHTML= red!==1
    ? 'Effective: <b>'+fmtInt(FLe)+' mm</b> at <b>f/'+fmt(Ne,2)+'</b> · aperture '+fmtInt(A)+' mm'
    : 'Aperture '+fmtInt(A)+' mm';

  // d badge
  if(activeFoc && activeFoc.d!=null){
    $('dbadge').innerHTML = (Math.abs(d-activeFoc.d)<1e-9)
      ? '<span class="badge ok">calibrated '+activeFoc.d+' µm/step</span>'
      : '<span class="badge ok">custom</span>';
  } else {
    $('dbadge').innerHTML = (d>0) ? '<span class="badge ok">custom</span>' : '';
  }

  // sampling classification
  var pxAcross=seeT/scale, samp, sampNote;
  if(pxAcross<2){samp='Undersampled';} else if(pxAcross>4){samp='Oversampled';} else {samp='Well sampled';}
  sampNote=fmt(pxAcross,1)+' px across seeing';

  // stat cards
  var cards=[
    ['CFZ (λ/3)', fmt(CFZ,1),'µm', fmtInt(CFZ/d)+' native steps',true,'Critical Focus Zone: the total drawtube travel over which focus stays diffraction-limited (CFZ = 4.88 x lambda x N-prime squared). Also shown as the number of native motor steps your focuser needs to cross it.'],
    ['λ/10 zone', fmt(L10,1),'µm', fmtInt(L10/d)+' native steps',false,'Tighter lambda/10 wavefront criterion (about 0.30x CFZ), a better real-world focus target for good star shape than the classic lambda/3 CFZ.'],
    ['NCFZ (seeing)', fmt(NCFZ,1),'µm', fmtInt(NCFZ/d)+' native steps',false,'Seeing-aware New Critical Focus Zone (GoldFocus): NCFZ = 0.00225 x seeing x sqrt(tolerance) x aperture x N-prime squared. Accounts for atmosphere and your chosen tolerance.'],
    ['Image scale', fmt(scale,2),'″/px', samp+' · '+sampNote,false,'Arcseconds per pixel = 206.265 x pixel size / effective focal length. Under/well/over-sampled is judged against total seeing.'],
    ['Total seeing', fmt(seeT,2),'″', 'diff limit '+fmt(diff,2)+'″',false,'Combined star FWHM = 0.2 x diffraction limit + atmospheric seeing. The smallest star size you can achieve.'],
    ['Focuser resolution', fmtInt(stepsPerPx),'steps', 'per 1 px HFR change',false,'Native motor steps needed to change a star HFR by one pixel = 2 x N-prime x pixel / (um per step). This is why autofocus must move many steps between exposures, not one.']
  ];
  $('statcards').innerHTML=cards.map(function(c){
    return '<div class="stat'+(c[4]?' hl':'')+'"><div class="k">'+c[0]+'<span class="tip" data-tip="'+c[5]+'">?</span></div><div class="v">'+c[1]+
      '<span class="u">'+c[2]+'</span></div><div class="note">'+c[3]+'</div></div>';
  }).join('');

  // problem bar
  var cfzSteps=CFZ/d;
  $('problembar').innerHTML = cfzSteps>800
    ? '<div class="warnbar">At this µm/step, one native motor step barely registers: it takes ~<b>'+fmtInt(stepsPerPx)+
      '</b> steps to change a star by a single pixel, and ~'+fmtInt(cfzSteps)+' steps just to cross the CFZ. Use the grouped step size below.</div>'
    : '';

  // per-software step computation
  function stepFor(w){
    var outerHFR, side=w.side||4, stepUm, pts, ok=true;
    if(w.mode==='fine'){ stepUm=1.5*Ne*p; outerHFR=null; side=null; pts=null; }
    else{
      if(w.mode==='rel'){ var k=(kOv>1.2?kOv:w.k); outerHFR=k*floorHFR; }
      else { outerHFR=w.targetHFR; }
      var inside=outerHFR*outerHFR-floorHFR*floorHFR;
      if(inside<=0){ ok=false; stepUm=0; }
      else{ var delta=2*Ne*p*Math.sqrt(inside); stepUm=delta/side; pts=2*side+1; }
    }
    var stepNat=stepUm/d;
    return {stepUm:stepUm,stepNat:stepNat,pts:pts,side:side,outer:outerHFR,ok:ok,basis:w.basis};
  }
  var selIdx=+$('sw').value, rows='';
  SW.forEach(function(w,i){
    var r=stepFor(w);
    var stepTxt = r.ok? fmtInt(Math.max(1,r.stepNat)) : 'n/a';
    var sweep = (r.ok&&r.side)? fmtInt(r.stepNat*2*r.side)+' steps' : (r.stepUm>0?'—':'—');
    var outer = r.outer? fmt(r.outer,1)+' px HFR' : (w.mode==='fine'?'0.75 px/step':'—');
    var pts = r.pts? r.pts : '—';
    rows+='<tr class="'+(i===selIdx?'sel':'')+'"><td>'+w.n+'</td><td class="step">'+stepTxt+
      '</td><td>'+pts+'</td><td>'+sweep+'</td><td>'+outer+'</td><td class="muted">'+r.basis+'</td></tr>';
  });
  $('swtable').querySelector('tbody').innerHTML=rows;
  $('swnote').innerHTML='Step = native motor steps between exposures — drop straight into the software’s step-size field. '+
    'Faster fitters (parabolic/quadratic) stay nearer the CFZ; hyperbolic &amp; linear-wing fitters want wider wings. '+
    'Min HFR used: <b>'+fmt(floorHFR,2)+' px</b> ('+floorSrc+') — step size is sensitive to this; for best results enter your measured in-focus HFR. '+
    (kOv>1.2?'<b>Outer-point override active: '+fmt(kOv,2)+'× min HFR.</b>':'');

  // stash for plot
  M={floorHFR:floorHFR,Ne:Ne,p:p,d:d,CFZ:CFZ,L10:L10,NCFZ:NCFZ,sel:stepFor(SW[selIdx]),selName:SW[selIdx].n};
  drawVC();
  saveState();
}

function drawVC(){
  var cv=$('vc'), dpr=window.devicePixelRatio||1;
  var w=cv.clientWidth, h=cv.clientHeight;
  cv.width=w*dpr; cv.height=h*dpr;
  var g=cv.getContext('2d'); g.setTransform(dpr,0,0,dpr,0,0); g.clearRect(0,0,w,h);
  if(!M.floorHFR) return;
  var pad={l:48,r:14,t:14,b:34};
  var plotW=w-pad.l-pad.r, plotH=h-pad.t-pad.b;
  var sel=M.sel;
  // x-range in native steps
  var half = (sel.ok&&sel.side)? sel.stepNat*sel.side*1.25 : (M.CFZ/M.d)*1.5;
  half=Math.max(half, (M.CFZ/M.d)*0.9, 5);
  var xr=half;
  // y-range
  function hfrAt(steps){ var delta=steps*M.d; var b=delta/(2*M.Ne*M.p);
    return Math.sqrt(M.floorHFR*M.floorHFR + b*b); }
  var yMax=hfrAt(xr)*1.08, yMin=0;
  function X(s){ return pad.l + (s+xr)/(2*xr)*plotW; }
  function Y(v){ return pad.t + (1-(v-yMin)/(yMax-yMin))*plotH; }

  // zone bands
  function band(halfUm,color,on){ if(!on)return; var hs=halfUm/M.d;
    g.fillStyle=color; g.fillRect(X(-hs),pad.t,X(hs)-X(-hs),plotH); }
  band(M.CFZ/2,'rgba(90,162,255,.16)',$('bCFZ').checked);
  band(M.L10/2,'rgba(55,214,122,.16)',$('bL10').checked);
  band(M.NCFZ/2,'rgba(255,176,32,.13)',$('bNCFZ').checked);

  // grid + axes
  g.strokeStyle='rgba(255,255,255,.08)'; g.lineWidth=1; g.fillStyle='#93a0c0'; g.font='11px system-ui';
  g.textAlign='center'; g.textBaseline='top';
  for(var i=-4;i<=4;i++){ var sx=xr*i/4, px=X(sx);
    g.beginPath(); g.moveTo(px,pad.t); g.lineTo(px,pad.t+plotH); g.stroke();
    g.fillText(fmtInt(sx),px,pad.t+plotH+6); }
  g.textAlign='right'; g.textBaseline='middle';
  for(var j=0;j<=4;j++){ var vy=yMin+(yMax-yMin)*j/4, py=Y(vy);
    g.strokeStyle='rgba(255,255,255,.06)'; g.beginPath(); g.moveTo(pad.l,py); g.lineTo(pad.l+plotW,py); g.stroke();
    g.fillStyle='#93a0c0'; g.fillText(fmt(vy,1),pad.l-6,py); }
  // axis labels
  g.textAlign='center'; g.fillStyle='#93a0c0'; g.textBaseline='top';
  g.fillText('focuser position (native motor steps from focus)', pad.l+plotW/2, h-14);
  g.save(); g.translate(12,pad.t+plotH/2); g.rotate(-Math.PI/2); g.fillText('star HFR (px)',0,0); g.restore();

  // focus line
  g.strokeStyle='rgba(255,255,255,.25)'; g.setLineDash([4,4]);
  g.beginPath(); g.moveTo(X(0),pad.t); g.lineTo(X(0),pad.t+plotH); g.stroke(); g.setLineDash([]);

  // V-curve
  g.strokeStyle='#5aa2ff'; g.lineWidth=2; g.beginPath();
  for(var s=-xr;s<=xr;s+=xr/160){ var yy=hfrAt(s); var Px=X(s),Py=Y(yy);
    if(s===-xr)g.moveTo(Px,Py); else g.lineTo(Px,Py); }
  g.stroke();

  // sample points for selected preset
  if(sel.ok && sel.side){
    g.fillStyle='#ff5a8a';
    for(var n=-sel.side;n<=sel.side;n++){ var pos=n*sel.stepNat; if(Math.abs(pos)>xr)continue;
      var yy=hfrAt(pos); g.beginPath(); g.arc(X(pos),Y(yy),4,0,7); g.fill(); }
  }
  // title tag
  g.fillStyle='#93a0c0'; g.textAlign='left'; g.textBaseline='top';
  g.fillText(M.selName.split(' —')[0].split(' (')[0], pad.l+4, pad.t+2);
}

// wire up
['fl','fr','red','px','see','tol','wl','dstep','ap','kfac','hfrMeas'].forEach(function(id){
  $(id).addEventListener('input',recompute); });
['bCFZ','bL10','bNCFZ'].forEach(function(id){ $(id).addEventListener('change',drawVC); });
$('sw').addEventListener('change',recompute);
window.addEventListener('resize',drawVC);
function esc(t){return (t||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function rebuildReducers(reds){
  var html='<option value="1.0">1.0× none</option>';
  (reds||[]).forEach(function(r){ var f=r[0];
    html+='<option value="'+f+'" label="'+f+'× '+esc(r[1])+'"></option>'; });
  html+='<option value="1.5" label="1.5× Barlow"></option><option value="2.0" label="2× Barlow"></option><option value="3.0" label="3× Barlow"></option>';
  $('redlist').innerHTML=html;
}
function buildScopeSelect(){
  var s=$('scope'), groups={};
  SCOPES.forEach(function(c,i){ (groups[c[0]]=groups[c[0]]||[]).push(i); });
  var html='<option value="">— manual entry / none —</option>';
  Object.keys(groups).sort(function(a,b){return a.toLowerCase().localeCompare(b.toLowerCase());}).forEach(function(b){
    html+='<optgroup label="'+esc(b)+'">';
    groups[b].forEach(function(i){var c=SCOPES[i];
      html+='<option value="'+i+'">'+esc(c[1])+' — '+c[3]+'mm f/'+c[4]+'</option>';});
    html+='</optgroup>';
  });
  s.innerHTML=html;
  s.onchange=function(){ if(s.value==='')return; var c=SCOPES[+s.value];
    $('fl').value=c[3]; $('fr').value=c[4]; rebuildReducers(c[5]); $('red').value='1.0'; recompute(); };
}
$('fl').addEventListener('input',function(){$('scope').value='';});
$('fr').addEventListener('input',function(){$('scope').value='';});
var FOCUSERS=[
  {id:'evrz',name:'JMI EVRZ — for ZWO EAF motor',d:2.54},
  {id:'evrp',name:'JMI EVRP — for Pegasus FocusCube3',d:2.63},
  {id:'manual',name:'Manual / custom — calibrate your own',d:null}
];
var activeFoc=null;
function buildFocuserSelect(){
  var s=$('foc');
  s.innerHTML=FOCUSERS.map(function(f,i){return '<option value="'+i+'">'+esc(f.name)+'</option>';}).join('');
  s.onchange=function(){ activeFoc=FOCUSERS[+s.value]; if(activeFoc.d!=null)$('dstep').value=activeFoc.d; recompute(); };
  activeFoc=FOCUSERS[0]; s.value='0'; if(FOCUSERS[0].d!=null)$('dstep').value=FOCUSERS[0].d;
}
// ---- remember the user's last configuration (localStorage) ----
var STATE_IDS=['fl','fr','red','px','see','tol','wl','dstep','ap','kfac','hfrMeas','cam','sw','scope','foc','calUnit'];
function saveState(){ try{ var o={}; STATE_IDS.forEach(function(id){ if($(id)) o[id]=$(id).value; });
  localStorage.setItem('fpfocus_v1',JSON.stringify(o)); }catch(e){} }
function loadState(){ try{ var s=localStorage.getItem('fpfocus_v1'); if(!s)return; var o=JSON.parse(s);
  STATE_IDS.forEach(function(id){ if($(id) && o[id]!==undefined && o[id]!=='') $(id).value=o[id]; });
  var fi=parseInt($('foc').value,10); if(!isNaN(fi)&&FOCUSERS[fi]) activeFoc=FOCUSERS[fi]; }catch(e){} }
buildScopeSelect(); buildCameraSelect(); buildSwSelect(); buildFocuserSelect();
// default camera = ASI2600MM Pro
(function(){ for(var i=0;i<CAMERAS.length;i++){ if(CAMERAS[i][1]==='ASI2600MM Pro'){ $('cam').value=i; break; } } })();
loadState(); recompute();